// This file maps the nucleus locale to the standardized language identifiers
// 'NUCLEUS_VERSION':'

export const nucleusLocaleToStandard = {
  'cs-cz': 'cs-CZ',
  'de': 'de-DE',
  'es-es': 'es-ES',
  'en': 'en-US',
  'fi-fi': 'fi-FI',
  'fr-fr': 'fr-FR',
  'it-it': 'it-IT',
  'ja-jp': 'ja-JP',
  'ko-kr': 'ko-KR',
  'nl-nl': 'nl-NL',
  'no-no': 'no-NO',
  'pl': 'pl-PL',
  'pt-br': 'pt-BR',
  'sv-se': 'sv-SE',
  'zh-cn': 'zh-CN',
};



// WEBPACK FOOTER //
// ./src/assets/locales/nucleusLocaleMappings.ts